(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var drawer = document.querySelector('[data-filter-panel]');
  if (!drawer) return;
  var scrim = document.querySelector('[data-filter-scrim]');
  // Re-parent to <body> so position:fixed is never trapped by a transformed ancestor.
  if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
  if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  var root = document.documentElement;
  var toggles = document.querySelectorAll('[data-filter-toggle]');

  function setOpen(on) {
    drawer.classList.toggle('is-open', on);
    if (scrim) scrim.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    root.classList.toggle('trc-drawer-open', on);
    document.body.classList.toggle('trc-drawer-open', on);
    toggles.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    if (on) { var c = drawer.querySelector('[data-filter-close]'); if (c) c.focus(); }
  }

  toggles.forEach(function (btn) { btn.addEventListener('click', function () { setOpen(true); }); });
  drawer.querySelectorAll('[data-filter-close]').forEach(function (btn) { btn.addEventListener('click', function () { setOpen(false); }); });
  if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && drawer.classList.contains('is-open')) setOpen(false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var formReadyAt = Date.now(); /* time-trap baseline: humans don't complete a form in seconds */
  var form = document.querySelector('.trc-c-form');

  /* ---- After a successful native submit the page reloads with the confirmation in
     place of the form. Hide the now-irrelevant heading/blurb and bring the thank-you
     into view, so the visitor never has to scroll up to find it. ---- */
  var nativeSuccess = document.querySelector('[data-c-native-success]');
  if (nativeSuccess) {
    var wrap0 = nativeSuccess.closest('.trc-c-formwrap');
    if (wrap0) Array.prototype.forEach.call(wrap0.querySelectorAll('.trc-c-step, h2, .trc-c-blurb'), function (el) { el.style.display = 'none'; });
    setTimeout(function () {
      nativeSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { nativeSuccess.focus({ preventScroll: true }); } catch (e) {}
    }, 120);
  }

  if (!form) return;
  var emailInput = form.querySelector('input[type="email"]');
  var btn = form.querySelector('.trc-c-submit');
  var hp = form.querySelector('.trc-c-hp input'); /* honeypot */

  /* ---- Disposable / throwaway email domains. Curated to the common generators;
     deliberately EXCLUDES privacy forwarders (Apple Hide My Email, DuckDuckGo,
     Firefox Relay, SimpleLogin, AnonAddy) so real customers aren't rejected. ---- */
  var BASE = [
    'mailinator.com','mailinator.net','mailinator2.com','sogetthis.com','reallymymail.com','binkmail.com','bobmail.info','suremail.info','spamherelots.com',
    'guerrillamail.com','guerrillamail.net','guerrillamail.org','guerrillamail.biz','guerrillamail.de','guerrillamail.info','guerrillamailblock.com','sharklasers.com','grr.la','pokemail.net','spam4.me',
    '10minutemail.com','10minutemail.net','10minutemail.org','10minutemail.de','20minutemail.com','20minutemail.it','minuteinbox.com',
    'temp-mail.org','temp-mail.com','temp-mail.io','tempmail.com','tempmail.net','tempmailo.com','tempr.email','tempmailaddress.com','tempemail.net','tempinbox.com','tempymail.com','mytemp.email','mytrashmail.com','tmail.com','tmpmail.org','tmpmail.net','tmpeml.com','tmails.net',
    'yopmail.com','yopmail.net','yopmail.fr','cool.fr.nf','jetable.fr.nf','nospam.ze.tc','nomail.xl.cx','mega.zik.dj','speed.1s.fr','courriel.fr.nf','moncourrier.fr.nf','monemail.fr.nf','monmail.fr.nf',
    'throwawaymail.com','throwam.com','getnada.com','nada.email','getairmail.com','maildrop.cc','dispostable.com','mailnesia.com','mintemail.com','mohmal.com','emailondeck.com','fakeinbox.com','fakemail.net','fakemailgenerator.com',
    'trashmail.com','trashmail.net','trashmail.de','trashmail.io','trashmail.me','trashmail.at','trash-mail.com','trash-mail.at','kurzepost.de','objectmail.com','proxymail.eu','rcpt.at','wegwerfmail.de','wegwerfmail.net','wegwerfmail.org','wegwerfemail.de',
    'discard.email','discardmail.com','discardmail.de','spambox.us','mailcatch.com','spamgourmet.com','moakt.com','moakt.cc','moakt.ws','inboxkitten.com','emltmp.com','mailpoof.com','luxusmail.org',
    '1secmail.com','1secmail.org','1secmail.net','esiix.com','wwjmp.com','xojxe.com','dpptd.com',
    'emailfake.com','emailfake.net','burnermail.io','meltmail.com','mailexpire.com','mailforspam.com','mailmetrash.com','mailnull.com','mailzilla.com','mailzilla.org','spamavert.com','spambog.com','spambog.de','spambog.ru','spamfree24.org','spamfree24.com','spamfree24.de','spamhole.com','spaminator.de','spamspot.com','deadaddress.com','despam.it','e4ward.com','harakirimail.com','incognitomail.org','jetable.org','jetable.com','jetable.net','mailme.lv','mailshell.com','mailsiphon.com','no-spam.ws','nobulk.com','nomail2me.com','nowmymail.com','pookmail.com','punkass.com','selfdestructingmail.com','sneakemail.com','spam.la','spamthis.co.uk','supergreatmail.com','thankyou2010.com','trbvm.com','veryrealemail.com','wh4f.org','willselfdestruct.com','mvrht.com','vomoto.com','zippymail.info','anonbox.net','byom.de','33mail.com','gustr.com','dayrep.com','einrot.com','fleckens.hu','jourrapide.com','rhyta.com','superrito.com','teleworm.us','armyspy.com',
    'mail.tm','mailtm.com','tempmail.plus','tempmailbox.com','tempmailbox.net','temp-mails.com','mail-temp.com','mailtemp.net','etempmail.net','etempmail.com','emailtemporanea.net','emailtemp.org','generator.email','mailtothis.com','tempemails.net','disbox.net','mail7.io','crazymailing.com','spamdecoy.net','robot-mail.com','tmpbox.net','inboxbear.com','altmails.com','maildim.com','mailcuk.com','muellmail.com','mailbox.in.ua','tafmail.com','vipmail.in.ua','tmpmails.net','one-time.email','onetimeemail.net','mailpwr.com','smailpro.com','flymail.tk','mailto.plus','fakemailbox.com','dropmail.me','10mail.org','yomail.info','mailsac.com','spamok.com','spamok.de','spamok.nl','spambox.org','tempmail.email','tempemail.co','emailnax.com','linshiyou.com','kzccv.com','qiott.com','fexpost.com','fextemp.com','sayheya.com','vjuum.com','laafd.com','txcct.com','yoggm.com','byteptr.com','vafyxh.com'
  ];

  var cfg = form.querySelector('[data-block-extra]');
  var extra = (cfg ? cfg.getAttribute('data-block-extra') || '' : '').toLowerCase().split(/[\s,;]+/);
  var blocked = [];
  BASE.concat(extra).forEach(function (d) {
    d = (d || '').trim().replace(/^@/, '');
    if (d && blocked.indexOf(d) === -1) blocked.push(d);
  });

  function domainOf(v) {
    var m = (v || '').trim().toLowerCase().match(/@([^@\s]+)$/);
    return m ? m[1] : '';
  }
  function isDisposable(v) {
    var d = domainOf(v);
    if (!d) return false;
    for (var i = 0; i < blocked.length; i++) {
      var b = blocked[i];
      if (d === b || d.slice(-(b.length + 1)) === '.' + b) return true; /* exact or subdomain, no false positives */
    }
    return false;
  }

  /* email error element */
  var emErr = document.createElement('small');
  emErr.className = 'trc-c-fielderr';
  var emField = emailInput ? emailInput.closest('.trc-c-field') : null;
  if (emField) emField.appendChild(emErr);
  var DISPOSABLE_MSG = "Please use a permanent email — temporary inboxes can't receive our reply.";
  function showEmErr(msg) { if (!emField) return; emErr.textContent = msg; emErr.classList.add('is-on'); emField.classList.add('has-err'); }
  function clearEmErr() { emErr.classList.remove('is-on'); if (emField) emField.classList.remove('has-err'); }

  if (emailInput) {
    emailInput.addEventListener('blur', function () {
      if (emailInput.value && isDisposable(emailInput.value)) showEmErr(DISPOSABLE_MSG); else clearEmErr();
    });
    emailInput.addEventListener('input', function () { if (emErr.classList.contains('is-on')) clearEmErr(); });
  }

  /* Soft bot-trap note (shown only if a submit arrives implausibly fast) */
  var botNote = null;
  function showBotNote(msg) {
    if (!botNote) {
      botNote = document.createElement('p');
      botNote.className = 'trc-c-botnote';
      if (btn && btn.parentNode) btn.parentNode.insertBefore(botNote, btn.nextSibling); else form.appendChild(botNote);
    }
    botNote.textContent = msg;
    botNote.classList.add('is-on');
  }

  /* Native submit — Shopify handles delivery reliably, with no fetch/redirect detection
     to misfire. We intercept only to (1) drop bots via honeypot + time-trap and
     (2) block a disposable email; anything else posts normally and reloads to the
     in-place confirmation. */
  form.addEventListener('submit', function (e) {
    /* 1) honeypot — a real visitor never sees or fills this field */
    if (hp && hp.value.trim() !== '') { e.preventDefault(); return; }
    /* 2) time-trap — no human completes the form in under 3s; a re-submit a moment later passes */
    if (Date.now() - formReadyAt < 3000) { e.preventDefault(); showBotNote('Take a moment to review your note, then send again.'); return; }
    /* 3) disposable email */
    if (emailInput && isDisposable(emailInput.value)) {
      e.preventDefault();
      showEmErr(DISPOSABLE_MSG);
      emailInput.focus();
      emailInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---- Custom dropdowns: replace the native <select> open list with a styled one,
     keeping the real <select> as the submitted value + no-JS fallback. ---- */
  function uid() { return Math.random().toString(36).slice(2, 8); }
  var allWraps = [];
  function closeAll(except) {
    allWraps.forEach(function (w) { if (w !== except && w.classList.contains('is-open')) w._close(); });
  }
  function enhanceSelect(sel) {
    if (sel.dataset.cEnhanced) return;
    sel.dataset.cEnhanced = '1';
    sel.classList.add('trc-c-sel-native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var field = sel.closest('.trc-c-field');
    var labelEl = field ? field.querySelector('label') : null;
    if (labelEl && !labelEl.id) labelEl.id = 'csl-' + uid();

    var wrap = document.createElement('div'); wrap.className = 'trc-c-sel';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'trc-c-sel-btn';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    if (labelEl) btn.setAttribute('aria-labelledby', labelEl.id);
    var valSpan = document.createElement('span'); valSpan.className = 'trc-c-sel-val';
    var caret = document.createElement('span'); caret.className = 'trc-c-sel-caret'; caret.setAttribute('aria-hidden', 'true');
    btn.appendChild(valSpan); btn.appendChild(caret);

    var list = document.createElement('ul');
    list.className = 'trc-c-sel-list'; list.setAttribute('role', 'listbox'); list.setAttribute('tabindex', '-1');
    if (labelEl) list.setAttribute('aria-labelledby', labelEl.id);

    var opts = [];
    Array.prototype.forEach.call(sel.options, function (o, i) {
      var li = document.createElement('li');
      li.className = 'trc-c-sel-opt'; li.id = 'cso-' + uid();
      li.setAttribute('role', 'option'); li.setAttribute('data-index', i);
      li.textContent = o.textContent;
      var selected = (i === sel.selectedIndex);
      if (selected) li.classList.add('is-selected');
      li.setAttribute('aria-selected', selected ? 'true' : 'false');
      list.appendChild(li); opts.push(li);
    });
    if (!opts.length) return;
    valSpan.textContent = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : '';

    wrap.appendChild(btn); wrap.appendChild(list);
    sel.parentNode.insertBefore(wrap, sel.nextSibling);
    allWraps.push(wrap);

    /* "Custom / please specify" → reveal a text input so the value can actually be entered.
       Submitted as a sibling "… — details" field; hidden+disabled (excluded) when not chosen. */
    var customTrigger = /custom|specif/i;
    var customInput = null;
    var labelText = labelEl ? labelEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (opts.some(function (_, i) { return customTrigger.test(sel.options[i].textContent); })) {
      customInput = document.createElement('input');
      customInput.type = 'text';
      customInput.className = 'trc-c-custom-field';
      customInput.name = sel.name.replace(/\]\s*$/, ' — details]');
      customInput.setAttribute('autocomplete', 'off');
      customInput.setAttribute('aria-label', (labelText || 'Detail') + ' — please specify');
      customInput.placeholder = /size/i.test(labelText) ? 'Type your exact size — e.g. 7 × 10 ft or 2.4 × 3 m' : 'Please specify';
      customInput.disabled = true;
      sel.parentNode.appendChild(customInput);
    }
    function syncCustom() {
      if (!customInput) return;
      var cur = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : '';
      var on = customTrigger.test(cur);
      customInput.classList.toggle('is-on', on);
      customInput.disabled = !on;
      if (!on) customInput.value = '';
    }

    var activeIdx = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;
    function isOpen() { return wrap.classList.contains('is-open'); }
    function setActive(i, scroll) {
      i = Math.max(0, Math.min(opts.length - 1, i));
      for (var k = 0; k < opts.length; k++) opts[k].classList.remove('is-active');
      opts[i].classList.add('is-active'); btn.setAttribute('aria-activedescendant', opts[i].id); activeIdx = i;
      if (scroll !== false) opts[i].scrollIntoView({ block: 'nearest' });
    }
    function open() { closeAll(wrap); wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); setActive(sel.selectedIndex < 0 ? 0 : sel.selectedIndex, false); }
    function close() { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.removeAttribute('aria-activedescendant'); }
    function choose(i) {
      sel.selectedIndex = i;
      for (var k = 0; k < opts.length; k++) { var s = (k === i); opts[k].classList.toggle('is-selected', s); opts[k].setAttribute('aria-selected', s ? 'true' : 'false'); }
      valSpan.textContent = sel.options[i].textContent;
      syncCustom();
      try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      close(); btn.focus();
    }
    function typeahead(ch) { ch = ch.toLowerCase(); for (var n = 1; n <= opts.length; n++) { var idx = (activeIdx + n) % opts.length; if (opts[idx].textContent.toLowerCase().charAt(0) === ch) { setActive(idx); break; } } }
    wrap._close = close;

    /* Focus stays on the button the entire time; the list is driven via aria-activedescendant.
       Avoids the focus-handoff race a separate listbox-focus introduces. */
    btn.addEventListener('click', function () { isOpen() ? close() : open(); });
    btn.addEventListener('keydown', function (e) {
      var k = e.key;
      if (!isOpen()) {
        if (k === 'ArrowDown' || k === 'Down' || k === 'ArrowUp' || k === 'Up' || k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); open(); }
        else if (k && k.length === 1) { open(); typeahead(k); }
        return;
      }
      if (k === 'ArrowDown' || k === 'Down') { e.preventDefault(); setActive(activeIdx + 1); }
      else if (k === 'ArrowUp' || k === 'Up') { e.preventDefault(); setActive(activeIdx - 1); }
      else if (k === 'Home') { e.preventDefault(); setActive(0); }
      else if (k === 'End') { e.preventDefault(); setActive(opts.length - 1); }
      else if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); choose(activeIdx); }
      else if (k === 'Escape' || k === 'Esc') { e.preventDefault(); close(); }
      else if (k === 'Tab') { close(); }
      else if (k && k.length === 1) { e.preventDefault(); typeahead(k); }
    });
    opts.forEach(function (li, i) {
      li.addEventListener('click', function () { choose(i); });
      li.addEventListener('mouseenter', function () { setActive(i, false); });
    });
    syncCustom();
  }

  if (window.NodeList && document.querySelectorAll) {
    Array.prototype.forEach.call(form.querySelectorAll('.trc-c-field select'), enhanceSelect);
    document.addEventListener('click', function (e) {
      allWraps.forEach(function (w) { if (w.classList.contains('is-open') && !w.contains(e.target)) w._close(); });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var cols = document.querySelectorAll('.trc-footer-col');
  if(!cols.length) return;
  var mq = window.matchMedia('(max-width: 640px)');
  function sync(){
    cols.forEach(function(d){
      if(mq.matches){ d.removeAttribute('open'); } else { d.setAttribute('open',''); }
    });
  }
  sync();
  if(mq.addEventListener){ mq.addEventListener('change', sync); }
  else if(mq.addListener){ mq.addListener(sync); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var header = document.querySelector('[data-trc].trc-nav-wrap');
  if (!header) return;
  if (header.dataset.transparent !== 'true') return;

  if (header.dataset.hasHero === 'true') {
    document.documentElement.classList.add('trc-hero-page');
  }

  function findHero() {
    return document.querySelector('.trc-hero, .trc-banner2, .trc-os-hero, .trc-cf-hero, .trc-jp-hero, .trc-l-hero, .trc-ct-hero, .trc-contact-hero');
  }

  function update() {
    var headerH = header.offsetHeight;
    document.documentElement.style.setProperty('--trc-headerH', headerH + 'px');
    var hero = findHero();
    var threshold;
    if (hero) {
      // Precise: transparent until the hero has scrolled mostly past the nav
      threshold = (hero.offsetTop + hero.offsetHeight) - headerH - 80;
    } else if (header.dataset.hasHero === 'true') {
      // Page opens with a dark hero whose exact class we don't track — fall back to ~one viewport
      threshold = window.innerHeight - headerH - 80;
    } else {
      header.classList.remove('trc-nav--over-hero');
      return;
    }
    if (window.scrollY < threshold) {
      header.classList.add('trc-nav--over-hero');
    } else {
      header.classList.remove('trc-nav--over-hero');
    }
  }

  // Run once and on scroll/resize. requestAnimationFrame throttles.
  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function(){ update(); ticking = false; });
      ticking = true;
    }
  }
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();

/* Keep --trc-headerH accurate on every page (the transparent handler above
   bails on non-hero pages) so the mega-menu drop offset always matches the
   real header height. No collapse — the brand name stays at all scroll positions. */
(function(){
  var header = document.querySelector('[data-trc].trc-nav-wrap');
  if (!header) return;
  function update(){
    document.documentElement.style.setProperty('--trc-headerH', header.offsetHeight + 'px');
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
})();

/* Mobile drawer: open/close + two-panel slide */
(function(){
  var burger = document.getElementById('trcBurger');
  var drawer = document.getElementById('trcDrawer');
  if (!burger || !drawer) return;
  var closeBtn = document.getElementById('trcDrawerClose');
  var back = document.getElementById('trcDrawerBack');
  var brand = document.getElementById('trcDrawerBrand');
  var panels = document.getElementById('trcDrawerPanels');
  var subPanels = drawer.querySelectorAll('.trc-drawer-sub');

  function resetDepth(){
    panels.classList.remove('is-deep');
    if (back) back.style.display = 'none';
    if (brand) brand.style.display = 'inline-flex';
    subPanels.forEach(function(p){ p.classList.remove('is-active'); });
  }
  function open(){
    drawer.classList.add('is-open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded','true');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('trc-drawer-open');
    resetDepth();
  }
  function close(){
    drawer.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded','false');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('trc-drawer-open');
    setTimeout(resetDepth, 500);
  }
  function deep(idx){
    subPanels.forEach(function(p){
      p.classList.toggle('is-active', p.getAttribute('data-sub-panel') === idx);
    });
    panels.classList.add('is-deep');
    if (back) back.style.display = 'inline-flex';
    if (brand) brand.style.display = 'none';
  }
  function shallow(){ resetDepth(); }

  burger.addEventListener('click', function(){ drawer.classList.contains('is-open') ? close() : open(); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (back) back.addEventListener('click', shallow);
  drawer.querySelectorAll('.trc-drawer-sub-open').forEach(function(btn){
    btn.addEventListener('click', function(){ deep(btn.getAttribute('data-sub')); });
  });
  drawer.addEventListener('click', function(e){
    if (e.target.closest('a[href]') && !e.target.closest('.trc-drawer-sub-open')) close();
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
})();

/* Solidify the over-hero header (transparent + cream logo -> cream bg + dark logo) once the
   hero has scrolled away, so the cream logo never sits on the cream content below. */
(function () {
  var header = document.querySelector('.trc-nav-wrap[data-has-hero="true"]');
  if (!header) return; // only runs on over-hero pages — keyed on the static data attribute, NOT the
                       // trc-nav--over-hero class, which the scroll controller above can strip on a
                       // scrolled hard-refresh before this runs (that race blanked the solid logo).
  // Lab spec: the header solidifies the moment scrolling begins, not after the hero ends.
  function threshold() { return 24; }
  var t = threshold(), ticking = false;
  function update() {
    var y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y > t) header.classList.add('is-solid');
    else header.classList.remove('is-solid');
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', function () { t = threshold(); update(); });
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function(){ t = threshold(); update(); }); }
  // Fallback: some smooth-scroll libraries virtualise scrolling and starve the scroll event.
  setInterval(update, 300);
  update();
})();

/* Shop-by-Colour hover preview: swap the side image/caption to the hovered family's
   collection image. Falls back to a flat colour block when a collection has no image. */
(function () {
  document.querySelectorAll('[data-colour-band]').forEach(function (band) {
    var prev = band.querySelector('[data-colour-preview]');
    if (!prev) return;
    var box = prev.querySelector('[data-colour-img]');
    var cap = prev.querySelector('[data-cap]');
    var hideT;
    band.querySelectorAll('.trc-swatch').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        clearTimeout(hideT);
        var hex = sw.getAttribute('data-hex');
        // Show the family colour (placeholder collection images were rendering as a flat pale box).
        if (hex === 'multi') {
          box.style.background = 'conic-gradient(#A4472F 0 25%, #C9A24B 0 50%, #2E3A5C 0 75%, #55603B 0)';
        } else {
          box.style.background = hex;
        }
        cap.textContent = sw.getAttribute('data-label') || '';
        // Position the floating card above the hovered swatch, clamped to the band's width
        // so it never spills past either edge. Absolute positioning = no layout shift.
        var bandW = band.clientWidth;
        var pw = prev.offsetWidth || 150;
        var center = sw.offsetLeft + (sw.offsetWidth / 2);
        prev.style.left = Math.max(0, Math.min(bandW - pw, center - (pw / 2))) + 'px';
        prev.classList.add('is-on');
      });
      sw.addEventListener('mouseleave', function () {
        hideT = setTimeout(function () { prev.classList.remove('is-on'); }, 350);
      });
    });
  });
})();

/* Broadcast the header's real height as --trc-header-h on :root so every page section
   (hero clearances, breadcrumbs) adapts automatically to any logo size on any device. */
(function () {
  var header = document.querySelector('.trc-nav-wrap');
  if (!header) return;
  function broadcast() {
    if (header.classList.contains('is-solid')) return; // only record the natural (top) height
    document.documentElement.style.setProperty('--trc-header-h', header.offsetHeight + 'px');
  }
  broadcast();
  window.addEventListener('resize', broadcast);
  if (window.ResizeObserver) new ResizeObserver(broadcast).observe(header);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(broadcast);
  window.addEventListener('load', broadcast);
})();
/* Mega-menu close affordances: Escape and scroll force the hover menu shut; re-entering a
   link group (or leaving the header) clears the force-closed state so hover works again. */
(function () {
  var wrap = document.querySelector('.trc-nav-wrap');
  if (!wrap) return;
  function forceClose() { wrap.classList.add('mega-x'); }
  function clear() { wrap.classList.remove('mega-x'); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) forceClose(); });
  window.addEventListener('scroll', forceClose, { passive: true });
  wrap.querySelectorAll('.trc-nav-link-group').forEach(function (g) { g.addEventListener('mouseenter', clear); });
  wrap.addEventListener('mouseleave', clear);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__trcHeroBreath) return;
  window.__trcHeroBreath = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var PERIOD = 36000; // full 1.0 -> 1.06 -> 1.0 cycle (matches the old 18s each way)
  function tick() {
    var els = document.querySelectorAll('.trc-hero-img--motion');
    if (els.length) {
      var t = (Date.now() % PERIOD) / PERIOD;          // 0..1 by wall clock
      var ease = (1 - Math.cos(t * Math.PI * 2)) / 2;  // smooth 0..1..0
      var s = (1.0 + ease * 0.06).toFixed(4);
      for (var i = 0; i < els.length; i++) { els[i].style.transform = 'scale(' + s + ')'; }
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

/* Push hero content below the ACTUAL header height (two-row desktop / one-row mobile),
   so the headline can never overlap the nav at any width. Runs regardless of motion prefs. */
(function () {
  if (window.__trcHeroClear) return;
  window.__trcHeroClear = true;
  // The TRC header is position:fixed at top:0, so its OWN rendered height is exactly the
  // clearance the hero needs. The previous version computed (header.bottom - hero.top); when
  // anything offset the hero's top, that subtraction under-measured and the nav overlapped
  // the headline. Measuring the header height directly removes that dependency entirely.
  function setClear() {
    var hero = document.querySelector('.trc-hero');
    if (!hero) return;
    var sel = ['.trc-nav-wrap', 'header[role="banner"]', '#shopify-section-header',
               '.section-header', '.header-wrapper', 'sticky-header', 'header'];
    var hdr = null;
    for (var i = 0; i < sel.length; i++) { var el = document.querySelector(sel[i]); if (el) { hdr = el; break; } }
    if (!hdr) return;
    var h = Math.round(hdr.getBoundingClientRect().height || hdr.offsetHeight || 0);
    if (h > 0 && h < 400) hero.style.setProperty('--trc-header-h', h + 'px');
  }
  if (document.readyState !== 'loading') setClear(); else document.addEventListener('DOMContentLoaded', setClear);
  window.addEventListener('load', setClear);
  window.addEventListener('resize', setClear);
  // header / web fonts can grow the header after first paint
  setTimeout(setClear, 200); setTimeout(setClear, 600); setTimeout(setClear, 1200);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setClear); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-ledger"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.currentScript && document.currentScript.closest ? null : null;
  var grids = document.querySelectorAll('.trc-ledger');
  if (!grids.length || !('IntersectionObserver' in window)) {
    // no observer support: reveal everything, leave numbers as-is
    document.querySelectorAll('.trc-ledger-stat').forEach(function(s){ s.classList.add('is-revealed'); });
    return;
  }
  var easeOutQuart = function(t){ return 1 - Math.pow(1 - t, 4); };
  function fmt(n, decimals, comma){
    var v = decimals > 0 ? n.toFixed(decimals) : Math.round(n).toString();
    return comma ? Number(v).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : v;
  }
  function runCount(el){
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var dur = parseInt(el.getAttribute('data-count-duration') || '1400', 10);
    var decimals = parseInt(el.getAttribute('data-count-decimals') || '0', 10);
    var comma = el.hasAttribute('data-count-comma');
    var orig = el.textContent;
    var start = performance.now();
    function step(now){
      var t = Math.min(1, (now - start) / dur);
      el.textContent = fmt(target * easeOutQuart(t), decimals, comma);
      if (t < 1) requestAnimationFrame(step); else el.textContent = orig;
    }
    requestAnimationFrame(step);
  }
  // reveal stats
  var statObs = new IntersectionObserver(function(entries, o){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-revealed'); o.unobserve(e.target); } });
  }, { threshold: 0.2 });
  document.querySelectorAll('.trc-ledger-stat').forEach(function(s){ statObs.observe(s); });
  // count numbers
  var countObs = new IntersectionObserver(function(entries, o){
    entries.forEach(function(e){ if (e.isIntersecting){ runCount(e.target); o.unobserve(e.target); } });
  }, { threshold: 0.4 });
  document.querySelectorAll('.trc-ledger [data-count]').forEach(function(el){ countObs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.trcInit) return;
    root.dataset.trcInit = '1';
    // Escape the smooth-scroll (Lenis) transformed wrapper: a transformed ancestor
    // re-bases position:fixed and traps z-index:300 below the header's stacking
    // context. Re-parenting to <body> restores true viewport fixing + veil coverage.
    var dupes = document.querySelectorAll('.trc-news-popup');
    for (var d = 0; d < dupes.length; d++) {
      if (dupes[d] !== root && dupes[d].id === root.id) dupes[d].parentNode.removeChild(dupes[d]);
    }
    if (root.parentElement !== document.body) document.body.appendChild(root);
    var KEY = 'trc_news_popup';
    var freq = parseInt(root.dataset.freq || '14', 10);
    var delay = (parseInt(root.dataset.delay || '8', 10)) * 1000;
    var trigger = root.dataset.trigger || 'delay';
    var htmlEl = document.documentElement;
    var opened = false;

    function seen() {
      try {
        var v = localStorage.getItem(KEY);
        if (!v) return false;
        if (v === 'subscribed') return true;
        if (freq <= 0) return false; // 0 days = show every load (for testing)
        return (Date.now() - parseInt(v, 10)) < freq * 86400000;
      } catch (e) { return false; }
    }
    function remember(val) { try { localStorage.setItem(KEY, val || String(Date.now())); } catch (e) {} }
    function open() {
      if (opened) return; opened = true;
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
      if (root.classList.contains('trc-news-popup--center')) {
        htmlEl.style.overflow = 'hidden';
        var inp = root.querySelector('input[type="email"]');
        if (inp) setTimeout(function () { try { inp.focus(); } catch (e) {} }, 350);
      }
    }
    function close() {
      root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
      htmlEl.style.overflow = ''; remember();
    }

    // If the visitor just subscribed, the page reloaded — show the success state once, then never nag.
    if (window.__trcNewsForceOpen) { remember('subscribed'); open(); }
    else if (!seen()) {
      if (trigger === 'exit') {
        var armed = false;
        setTimeout(function () { armed = true; }, 2500);
        document.addEventListener('mouseout', function (e) {
          if (armed && !opened && !e.relatedTarget && e.clientY <= 0 && !seen()) open();
        });
        // exit-intent doesn't exist on touch — fall back to the delay there
        if (window.matchMedia('(max-width: 768px)').matches) {
          setTimeout(function () { if (!seen()) open(); }, delay);
        }
      } else if (trigger === 'scroll') {
        var onScroll = function () {
          if (!opened && window.scrollY > document.body.scrollHeight * 0.35 && !seen()) {
            open(); window.removeEventListener('scroll', onScroll);
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        setTimeout(function () { if (!seen()) open(); }, delay);
      }
    }

    var closers = root.querySelectorAll('[data-news-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && root.classList.contains('is-open')) close();
    });
  }
  function boot() {
    var nodes = document.querySelectorAll('.trc-news-popup');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
